import { Box, styled } from "@mui/material";
import { colors } from '../../../theme/colors';

export const FinalShortlistedWrapper = styled(Box)({
  padding: "24px",
  background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",
  minHeight: "100%",

  "& .page-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "24px",
    flexWrap: "wrap",
    gap: "16px",
  },

  "& .page-title": {
    fontSize: "28px",
    fontWeight: 700,
    color: colors.primary,
    lineHeight: 1.2,
    marginBottom: "6px",
  },

  "& .page-subtitle": {
    fontSize: "14px",
    color: "#637381",
    lineHeight: 1.5,
  },

  "& .filters-card": {
    background: "#ffffff",
    border: "1px solid rgba(145, 158, 171, 0.24)",
    borderRadius: "12px",
    padding: "16px 20px",
    boxShadow: "0 2px 8px rgba(127, 29, 29, 0.06)",
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: "20px",
  },

  "& .table-card": {
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    backgroundColor: "#fff",
    border: "1px solid #dde7f0",
    marginBottom: "20px",
    overflow: "hidden",
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "lightgray",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.primary,
      borderRadius: "10px",
      border: "2px solid lightgray",
    },
  },

  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },

  "& .MuiTableCell-body": {
    fontSize: "14px",
    color: "#374151",
    borderBottom: "1px solid #f0f0f0",
  },

  "& .MuiTableRow-root:last-child .MuiTableCell-body": {
    borderBottom: "none",
  },

  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
  },
  "& .MuiTableRow-root:hover": {
    backgroundColor: colors.primaryLight,
  },

  "& .candidate-name": {
    fontWeight: 600,
    color: "#1a1a1a",
    fontSize: "14px",
  },

  "& .candidate-sub": {
    fontSize: "12px",
    color: "#919eab",
    marginTop: "2px",
  },

  "& .recruiter-name": {
    fontWeight: 500,
    color: "#374151",
    fontSize: "14px",
  },

  "& .pagination-bar": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "16px",
  },

  "& .pagination-info": {
    fontSize: "13px",
    color: "#637381",
  },

  "& .pagination-buttons": {
    display: "flex",
    gap: "8px",
  },

  "& .pagination-btn": {
    backgroundColor: colors.primary,
    color: "#fff",
    textTransform: "none",
    borderRadius: "8px",
    fontWeight: 500,
    fontSize: "13px",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: colors.primaryHover,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.buttonDisabled.background,
      color: colors.buttonDisabled.color,
      opacity: 1,
      cursor: "not-allowed",
    },
  },

  "@media (max-width: 900px)": {
    padding: "16px",

    "& .page-header": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& .pagination-bar": {
      flexDirection: "column",
      gap: "12px",
      alignItems: "stretch",
    },
  },
});
